export var SELECT_CAT = 'SELECT_CAT';
export var selectCat = function selectCat(selectedCat) {
  return {
    type: SELECT_CAT,
    selectedCat: selectedCat
  };
};